import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
  pulse?: boolean;
}
export function Button({
  children,
  href,
  className = '',
  pulse = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center bg-brand-500 hover:bg-brand-400 text-white font-bebas text-2xl tracking-wide py-4 px-8 rounded-lg transition-all duration-300 shadow-glow hover:shadow-glow-lg uppercase';
  const content = <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className="w-full" data-id="element-154">
      {pulse ? <motion.button animate={{
      boxShadow: ['0 0 20px rgba(249, 115, 22, 0.4)', '0 0 40px rgba(249, 115, 22, 0.8)', '0 0 20px rgba(249, 115, 22, 0.4)']
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className={`${baseStyles} w-full ${className}`} {...props} data-id="element-155">
          {children}
        </motion.button> : <button className={`${baseStyles} w-full ${className}`} {...props} data-id="element-156">
          {children}
        </button>}
    </motion.div>;
  if (href) {
    return <a href={href} className="w-full block" onClick={e => {
      if (href.startsWith('#')) {
        e.preventDefault();
        document.querySelector(href)?.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }} data-id="element-157">
        {content}
      </a>;
  }
  return content;
}